export interface VoiceDescriptionProps {
  voiceIcon: string;
  voiceName: string;
  voiceGender: string;
  nativeLanguage: string;
  accent: string;
  origin: string;
  age: string;
  emotion: string;
  style: string;
  previewPrompt: { language: string; text: string }[];
  freeText: { language: string; text: string }[];
}

// Define the priority rules
export const priorityMap: { [key: string]: string[] } = {
  "de-de": [
    "de-at",
    "en-gb",
    "en-us",
    "fr-fr",
    "es-419",
    "it-it",
    "ja-jp",
    "pt-br",
    "tr-tr",
    "zh-cn",
  ],
  "de-at": [
    "de-de",
    "en-gb",
    "en-us",
    "fr-fr",
    "es-419",
    "it-it",
    "ja-jp",
    "pt-br",
    "tr-tr",
    "zh-cn",
  ],
  "en-gb": [
    "en-us",
    "de-de",
    "de-at",
    "fr-fr",
    "es-419",
    "it-it",
    "ja-jp",
    "pt-br",
    "tr-tr",
    "zh-cn",
  ],
  "en-us": [
    "en-gb",
    "de-de",
    "de-at",
    "fr-fr",
    "es-419",
    "it-it",
    "ja-jp",
    "pt-br",
    "tr-tr",
    "zh-cn",
  ],
  "fr-fr": [
    "en-gb",
    "en-us",
    "de-de",
    "de-at",
    "es-419",
    "it-it",
    "ja-jp",
    "pt-br",
    "tr-tr",
    "zh-cn",
  ],
  "es-419": [
    "de-de",
    "de-at",
    "en-gb",
    "en-us",
    "fr-fr",
    "it-it",
    "ja-jp",
    "pt-br",
    "tr-tr",
    "zh-cn",
  ],
  "it-it": [
    "de-de",
    "de-at",
    "en-gb",
    "en-us",
    "fr-fr",
    "es-419",
    "ja-jp",
    "pt-br",
    "tr-tr",
    "zh-cn",
  ],
  "ja-jp": [
    "de-de",
    "de-at",
    "en-gb",
    "en-us",
    "fr-fr",
    "es-419",
    "it-it",
    "pt-br",
    "tr-tr",
    "zh-cn",
  ],
  "pt-br": [
    "de-de",
    "de-at",
    "en-gb",
    "en-us",
    "fr-fr",
    "es-419",
    "it-it",
    "ja-jp",
    "tr-tr",
    "zh-cn",
  ],
  "tr-tr": [
    "de-de",
    "de-at",
    "en-gb",
    "en-us",
    "fr-fr",
    "es-419",
    "it-it",
    "ja-jp",
    "pt-br",
    "zh-cn",
  ],
  "zh-cn": [
    "de-de",
    "de-at",
    "en-gb",
    "en-us",
    "fr-fr",
    "es-419",
    "it-it",
    "ja-jp",
    "pt-br",
    "tr-tr",
  ],
};
